<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 utils.in_rem(72px);
    gap: utils.in_rem(18px);
  }
</style>

<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";

  //@ts-check

  /**
   * @typedef {Object} Props
   * @property {import('svelte').Snippet} [children]
   * @property {string} [style]
   */

  /** @type {Props} */
  let { children, style = "" } = $props();

  let display = $state(false);
  onMount(() => {
    display = true;
  });
</script>

{#if display}
  <div class="slide" {style} transition:fade={{ duration: 1000 }}>
    {@render children?.()}
  </div>
{/if}
